import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
//import { SplitText } from 'gsap/SplitText';
//gsap.registerPlugin(SplitText);

const slideLeftWords = () => {

    // Animazione scroll intro
    const wrapper = document.querySelector('.words-scroll__wrapper');

    if(wrapper){

        const wordsW = wrapper.offsetWidth;
        const vW = window.innerWidth;

        //const xleft = window.innerWidth > 768 ? (50 + wordsW - (vW / 2)) : (50 + wordsW);
        const xleft = 50 + wordsW;

        gsap.to('.words-scroll__wrapper', {
            x: `-${xleft}px`,
            duration: 1,
            ease: "none",
            scrollTrigger: {
                trigger: '[data-word-slide-left]',
                start: "top top",
                end: "bottom 80%",
                once: false,
                scrub: true
            }
        });
    }
}

const set = (el) => {
    
    el.classList.add('readyForAni');
    
    let elems = el.querySelectorAll('.title__char, .play-video, .img-in-title, .title-img');
    let sup = el.querySelectorAll('sup');

    if(elems.length <= 0 && sup.length <= 0) return;

    if(elems.length > 0){
        gsap.set(elems, {y: '120%', opacity: 0});
    }

    if(sup.length > 0){
        gsap.set(sup, {y: '80%', opacity: 0});
    }

    return {elems, sup};
}


const animateIn = ({el, speed = 0.04, delay = 0, elems, sup}) => {
    
    let tl = gsap.timeline();

    tl.to(elems, {
    scrollTrigger: {
        trigger: el,
        start: "top 80%"
    }, y: 0, ease: "power3.out", opacity: 1,duration: 0.8, stagger: speed}, delay);

    if(sup.length > 0){
        tl.to(sup, {y: 0, opacity: 1, ease: "power3.out", duration: 0.4});
    }
}

const animateEl = (el, delay) => {

    if(el.getAttribute('data-noAnimation') != null) return;

    let childrens = set(el);

    if(childrens){
        animateIn({el, delay, ...childrens});
    }

}

const setHeroElems = () => {

    let imgHeroElems = document.querySelectorAll('[data-animateInHeroImg]');
    if (imgHeroElems.length > 0) {
        imgHeroElems.forEach((el) => {
            gsap.set(el, { scale: 1.6, y: '40%', x: '-10%'});
        });
    }
}

const animateHeroElems = () => {

    let imgHeroElems = document.querySelectorAll('[data-animateInHeroImg]');
    if (imgHeroElems.length > 0) {
        imgHeroElems.forEach((el) => {
            gsap.to(el, { scale: 1, y: '0%', x: 0, ease: "power.inOut", duration: 1.6 });
        });
    }
}

const init = () => {

    let elems = document.querySelectorAll('[data-animateInText]');
    
    if(elems.length > 0){

        let simpleSplitText = new SplitText('[data-animateInText]', { type: "words,chars", wordsClass:"title__word", charsClass:"title__char" });

        elems.forEach((el) => {
            let childrens = set(el);
            let speed = el.getAttribute('data-animateInText');
            animateIn({el, speed, ...childrens});
        });
    }

}

export default { animateEl, init, setHeroElems, animateHeroElems, slideLeftWords };